export interface IDSPApi {
  dsp_id: number;
  code: string;
  name: string;
  is_external: boolean;
  logo_url: string;
  external_exchange_id: number | null;
}

export default class DSP {
  id: number;

  code: string;

  name: string;

  isExternal: boolean;

  logoUrl: string;

  externalExchangeID: number | null;

  constructor(
    id: number,
    code: string,
    name: string,
    isExternal: boolean,
    logoUrl: string,
    externalExchangeID: number | null = null,
  ) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.isExternal = isExternal;
    this.logoUrl = logoUrl;
    this.externalExchangeID = externalExchangeID;
  }

  static fromApi(apiObject: IDSPApi): DSP {
    return new DSP(
      apiObject.dsp_id,
      apiObject.code,
      apiObject.name,
      apiObject.is_external,
      apiObject.logo_url,
      apiObject.external_exchange_id,
    );
  }

  toApi(): IDSPApi {
    return {
      dsp_id: this.id || undefined,
      code: this.code,
      name: this.name,
      is_external: this.isExternal,
      logo_url: this.logoUrl,
      external_exchange_id: this.externalExchangeID,
    };
  }
}
